import datadogRum from '../../../utility/datadog-util';
import { SystemActions } from '../../../store/features/system';
import config from '../../../global/env.config';
const datadogMiddleware = (store) => (next) => (action) => {
    if (config.env === 'development') {
        next(action);
        return;
    }
    if (action && action.type === SystemActions.SET_USER) {
        const { id, firstName, lastName, email } = action.payload;
        const userData = {
            name: `${firstName} ${lastName}`,
            email,
        };
        if (id) {
            userData['id'] = id.toString();
        }
        datadogRum.setUser(userData);
    }
    next(action);
};
export default datadogMiddleware;
